import { ReactComponent as Facebook } from '../icon/facebook.svg';
import { ReactComponent as Youtube } from '../icon/youtube.svg';
import { ReactComponent as Telegram } from '../icon/telegram.svg';
import { ReactComponent as Tiktok } from '../icon/tiktok.svg';
import { ReactComponent as Instagram } from '../icon/instagram.svg';
import { ReactComponent as Mail } from '../icon/mail.svg';
import { ReactComponent as Linkedin } from '../icon/linkedin.svg';
import { ReactComponent as Global } from '../icon/global.svg';

type props = {
    color: string
}

const Social: React.FC<props> = ({ color }) => {

    return <div className='row' style={{ margin: '1rem 0', gap: '5px' }}>
        <a aria-label='Youtube' className='socialTap' style={{ color: color }} href='https://www.youtube.com/@NicolaSagliano'><Youtube width={24} height={24} /></a>
        <a aria-label='Instagram' className='socialTap' style={{ color: color }} href='https://www.instagram.com/nicola_sagliano/'><Instagram width={24} height={24} /></a>
        <a aria-label='Tiktok' className='socialTap' style={{ color: color }} href='https://www.tiktok.com/@nicola_sagliano'><Tiktok width={24} height={24} /></a>
        <a aria-label='Telegram' className='socialTap' style={{ color: color }} href='https://t.me/sagliaofferte'><Telegram width={24} height={24} /></a>
        <a aria-label='Mail' className='socialTap' style={{ color: color }} href='mailto:nicolasaglianobusiness@gmail.com' target="_top"><Mail width={24} height={24} /></a>
        {/* <a aria-label='Facebook' className='socialTap' style={{ color: color }} href='https://www.facebook.com/nicolasaglianotech'><Facebook width={24} height={24} /></a> */}
        {/* <a aria-label='Linkedin' className='socialTap' style={{ color: color }} href='https://www.linkedin.com/in/nicola-sagliano/'><Linkedin width={24} height={24} /></a> */}
        {/* <a aria-label='Website' className='socialTap' style={{ color: color }} href='https://nicolasagliano.com/'><Global width={24} height={24} /></a> */}
    </div>
}

export default Social